import { useEffect, useState } from "react";
import NavbarBlock from "../../Blocks/NavbarBlock/NavbarBlock";
import './AddNewFirmware.scss'
import md5 from 'md5'
import AddUserPopup from "../Popup/AddUserSuccess";
import EditUserPopupNone from '../Popup/EditUserPopupNone'
import {useNavigate} from "react-router-dom";

export default function AddNewFirmware({ token, onLogout }) {
    const navigate = useNavigate();
    const [deviceType, setDeviceType] = useState('')
    // const [hwVersion, setHwVersion] = useState('')
    // const [swVersion, setSwVersion] = useState(null)
    const [notes, setNotes] = useState('')
    const [file, setFile] = useState()
    const [fileName, setFileName] = useState()
    // const [fwFile, setFwFile] = useState()
    // const [fsFile, setFsFile] = useState()

    const [addFirmwarePopup, setAddFirmwarePopup] = useState(false)
    const [errorText, setErrorText] = useState('');
    const [wrongPopup, setWrongPopup] = useState(false)

    const addNewFirmware = () => {
        if (!file || ! deviceType) {
            return alert('Fill at least "Device Type" and "Content"')
        }
        const today = new Date();

        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        const formattedDate = `${year}-${month}-${day}`;

        let accesToken = localStorage.getItem('accesToken')
        let AuthStr = 'Bearer ' + accesToken
        let raw = JSON.stringify({
            // "sw_version": swVersion,
            // "hw_version": hwVersion,
            "notes": notes,
            "device_type": deviceType,
            "release_date": formattedDate,
            "file_name": fileName,
            "content": file,
            // "content_fw": fwFile,
            // "content_fs": fsFile
        });

        const requestOptions = {
            method: 'post',
            body: raw,
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        };
        fetch('https://apiv1.zis.ru/sw-versions', requestOptions)
            .then(response => response.json())
            .then(result => {

                if (result?.id) {
                    setAddFirmwarePopup(true)
                }
                else {
                    setWrongPopup(true)
                    setErrorText(result?.description?.en || 'Something went wrong');
                }


            })
            .catch(error => console.log(error, 'error'))
    }

    useEffect(() => {
        let accesToken = localStorage.getItem('accesToken');
        if (!accesToken) {

            window.location.href = '/'
            return false;
        }
    }, [])

    const closeAddFirmwarePopup = () => {
        setAddFirmwarePopup(!addFirmwarePopup)
        navigate('/firmwares')
    }

    const closeWrongPopup = () => {
        setWrongPopup(!wrongPopup)
    }

    /*const onSwVersionChange = (ev) => {
        const val = ev.target.value;
        if (!val?.length || /^[0-9.]+$/gm.test(val)) {
            setSwVersion(val)
        }
    }*/

    const handleFileChange = (setterFn) => (ev) => {
        const selectedFile = ev.target?.files[0]
        if (!selectedFile) return;

        const reader = new FileReader();

        reader.onload = () => {
            setterFn(reader.result?.split(';base64,')?.[1] || '');
        };

        reader.onerror = (error) => {
            console.error("Error reading file:", error);
        };

        setFileName(selectedFile.name)
        reader.readAsDataURL(selectedFile); // Конвертирует файл в base64
    }

    return (
        <div className="addNew_admins"  >
            {addFirmwarePopup ? <AddUserPopup text={'Firmware has been added successfully'} onClick={closeAddFirmwarePopup} /> : ''}
            {wrongPopup ? <EditUserPopupNone onClick={closeWrongPopup} errorText={errorText} /> : ''}
            <NavbarBlock token={token} onLogout={onLogout} />
            <div className="container_addnew_rightPart">
                <h3>Add New Firmware</h3>
                <div className="inputDiv">
                    <p>Device Type:</p>
                    <select name="device_type" id="device_type" onChange={e => setDeviceType(e.target.value)}>
                        <option value="">--Select--</option>
                        <option value="outlet">Outlet</option>
                    </select>
                </div>
                {/*<div className="inputDiv">
                    <p>HW Version:</p>
                    <input placeholder="1.2.0" type={''} value={hwVersion} onChange={e => setHwVersion(e.target.value)} />
                </div>
                <div className="inputDiv">
                    <p>SW Version:</p>
                    <input placeholder="3.1.2" value={swVersion} onChange={onSwVersionChange} />
                </div>*/}
                <div className="inputDiv">
                    <p>Notes:</p>
                    <input placeholder="Notes (optional) ..." value={notes} onChange={e => setNotes(e.target.value)} />
                </div>
                <div className="inputDiv">
                    <p>Content:</p>
                    <input type={'file'} onChange={handleFileChange(setFile)} />
                </div>
                {/*<div className="inputDiv">
                    <p>FW Content:</p>
                    <input type={'file'} onChange={handleFileChange(setFwFile)} />
                </div>
                <div className="inputDiv">
                    <p>FS Content:</p>
                    <input type={'file'} onChange={handleFileChange(setFsFile)} />
                </div>*/}
                <button
                    onClick={() => addNewFirmware()}
                >
                    <p>Save</p>
                </button>
            </div>
        </div>
    )
}
